import { Tab } from '@headlessui/react'
import classNames from 'classnames'

import { withProgramRegistrationsStore } from '@/app/dashboard/events/stores/use-program-registrations'

import CourseFee from './components/courseFee'
import Cover from './components/cover'
import Description from './components/description'
import Details from './components/details'
import Faq from './components/faq'
import Meta from './components/meta'
import Methodology from './components/methodology'
import Reviews from './components/reviews'
import { withProgramStore } from './stores/use-program'

const tabs = ['ABOUT', 'COURSE FEE', 'REVIEWS', 'FAQs']

const ProgramHome = () => {
  const changeValue = (string) => {
    if (string === 'CourseFee') {
      return 'Course Fee'
    }

    return string
  }
  return (
    <div className='align-center flex h-[100%] min-h-full flex-wrap bg-theme-turquoise px-14'>
      <div className='pt-custom-150 flex-[0_0_100%]'>
        <Meta />
        <div className='mx-auto max-w-[566px]'>
          <div className='p-landing'>
            <Cover />
            <Details />
            <div className='mx-auto my-5 w-full'>
              <Tab.Group as='div'>
                <div className='custom-font border-b border-gray-200'>
                  <Tab.List className='-mb-px flex justify-between'>
                    {tabs.map((tab) => (
                      <Tab
                        key={tab}
                        className={({ selected }) =>
                          classNames(
                            selected
                              ? 'custom-font border-gray-600 font-bold text-gray-900'
                              : 'border-transparent font-bold text-gray-900 hover:border-gray-300 hover:text-gray-800',
                            'custom-font whitespace-nowrap border-b py-3',
                          )
                        }
                      >
                        {changeValue(tab)}
                      </Tab>
                    ))}
                  </Tab.List>
                </div>
                <Tab.Panels>
                  <Description />
                  <CourseFee />
                  <Reviews />
                  <Faq />
                </Tab.Panels>
              </Tab.Group>
            </div>
            <div className='methology-wrapper'>
              <Methodology />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .custom-font {
          font-size: calc(15px + (30 - 15) * (100vw - 375px) / (1920 - 375));
        }
      `}</style>
    </div>
  )
}

export default withProgramRegistrationsStore(withProgramStore(ProgramHome))
